import React from 'react';
import { IconProps } from '.';

const SvgBoxKitto = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#000'
        d='M18.667 2H5.333A3.333 3.333 0 0 0 2 5.333v13.334A3.333 3.333 0 0 0 5.333 22h13.334A3.333 3.333 0 0 0 22 18.667V5.333A3.333 3.333 0 0 0 18.667 2Z'
      />
      <path
        fill='#fff'
        d='M12.367 7v2.606c0 .587-.376.895-.748.895s-.748-.307-.748-.895V7H7v10h3.837v-3.27h2.325V17H17v-5.259h-1.97L17 7h-4.633Z'
      />
    </svg>
  );
};

export default SvgBoxKitto;
